/**
 * Gift Wrapping Module
 * カート内ギフトラッピング管理 + 商品ページ対応
 */
if (window.GiftWrappingLoaded) {
  console.log('[GiftWrapping] Already loaded, skipping');
} else {
  window.GiftWrappingLoaded = true;
(function() {
  'use strict';
  const GiftWrapping = {
    isProcessing: false,
    initialized: false,
    init() {
      if (this.initialized) return;
      this.initialized = true;
      console.log('[GiftWrapping] Initializing');
      this.bindCartEvents();
      this.interceptAddToCartButton();
      this.bindProductPageEvents();
      this.cleanOrphanedWraps();
    },
    bindCartEvents() {
      document.addEventListener('click', (e) => {
        const addBtn = e.target.closest('[data-gift-wrap-add]');
        const removeBtn = e.target.closest('[data-gift-wrap-remove]');
        // 2026-07 fix: 処理中のブロックはラッピング操作ボタンのみに限定
        // （以前はページ全体のクリックを握りつぶし、チェックアウト操作まで阻害していた）
        if (this.isProcessing) {
          if (addBtn || removeBtn) { e.preventDefault(); e.stopPropagation(); }
          return;
        }
        if (addBtn) { e.preventDefault(); e.stopPropagation(); this.addGiftWrap(addBtn); return; }
        if (removeBtn) { e.preventDefault(); e.stopPropagation(); this.removeGiftWrap(removeBtn); return; }
      });
    },
    interceptAddToCartButton() {
      document.addEventListener('click', (e) => {
        const addToCartBtn = e.target.closest(
          '[data-type="add-to-cart-form"] button[type="submit"], form[action*="/cart/add"] button[type="submit"], .shopify-product-form button[type="submit"]'
        );
        if (!addToCartBtn) return;
        const giftWrapCheckbox = document.querySelector('[data-gift-wrapping-toggle]');
        if (!giftWrapCheckbox || !giftWrapCheckbox.checked) return;
        if (this.isProcessing) { e.preventDefault(); e.stopImmediatePropagation(); return; }
        e.preventDefault();
        e.stopImmediatePropagation();
        console.log('[GiftWrapping] Intercepted add-to-cart click');
        this.handleProductFormWithGiftWrap(addToCartBtn);
      }, true);
    },
    async handleProductFormWithGiftWrap(button) {
      if (this.isProcessing) return;
      this.isProcessing = true;
      button.disabled = true;
      try {
        const form = button.closest('form');
        if (!form) throw new Error('Form not found');
        const formData = new FormData(form);
        const mainVariantId = formData.get('id');
        const mainResponse = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: parseInt(mainVariantId), quantity: parseInt(formData.get('quantity') || 1) })
        });
        if (!mainResponse.ok) throw new Error('Failed to add main product');
        const cartResponse = await fetch('/cart.js');
        const cart = await cartResponse.json();
        const mainItem = cart.items.find(item => String(item.variant_id) === String(mainVariantId));
        if (!mainItem) throw new Error('Main item not found in cart');
        const selectedRadio = document.querySelector('.gift-wrapping__radio:checked');
        if (selectedRadio) {
          const wrapVariantId = selectedRadio.dataset.variantId;
          const quantityInput = document.querySelector('[data-gift-wrap-quantity]');
          const wrapQuantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1;
          console.log('[GiftWrapping] Adding wrap product, qty:', wrapQuantity);
          const parentLabel = mainItem.product_title + (mainItem.variant_title ? ' / ' + mainItem.variant_title : '');
          await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: parseInt(wrapVariantId), quantity: wrapQuantity,
              properties: { '_parent_line_key': mainItem.key, '_gift_wrap_type': 'individual', 'ラッピング対象': parentLabel }
            })
          });
        }
        window.location.reload();
      } catch (error) {
        console.error('[GiftWrapping] Error:', error);
        this.isProcessing = false;
        button.disabled = false;
        alert('カートへの追加に失敗しました。もう一度お試しください。');
      }
    },
    bindProductPageEvents() {
      document.addEventListener('change', (e) => {
        if (e.target.matches('[data-gift-wrapping-toggle]')) this.toggleProductOptions(e.target);
        if (e.target.matches('.gift-wrapping__radio')) this.updatePriceField(e.target);
      });
      document.addEventListener('click', (e) => {
        const minusBtn = e.target.closest('[data-gift-wrap-qty-minus]');
        const plusBtn = e.target.closest('[data-gift-wrap-qty-plus]');
        if (minusBtn || plusBtn) {
          const input = (minusBtn || plusBtn).closest('.gift-wrapping__quantity-selector')?.querySelector('[data-gift-wrap-quantity]');
          if (!input) return;
          let val = parseInt(input.value) || 1;
          if (minusBtn) val = Math.max(1, val - 1);
          if (plusBtn) val = Math.min(10, val + 1);
          input.value = val;
        }
      });
    },
    async addGiftWrap(button) {
      if (this.isProcessing) return;
      this.isProcessing = true;
      button.disabled = true;
      const variantId = button.dataset.variantId;
      const parentKey = button.dataset.parentKey;
      const dropdown = button.closest('[data-gift-wrap-dropdown]');
      if (dropdown) dropdown.classList.add('gift-wrap-dropdown--loading');
      try {
        // カートAPIから親商品名を取得
        const cartRes = await fetch('/cart.js');
        const cart = await cartRes.json();
        const parentItem = cart.items.find(item => item.key === parentKey);
        const parentLabel = parentItem
          ? parentItem.product_title + (parentItem.variant_title ? ' / ' + parentItem.variant_title : '')
          : '';
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: parseInt(variantId), quantity: 1,
            properties: { '_parent_line_key': parentKey, '_gift_wrap_type': 'individual', 'ラッピング対象': parentLabel }
          })
        });
        if (!response.ok) throw new Error('Failed to add gift wrap');
        window.location.reload();
      } catch (error) {
        console.error('[GiftWrapping] Add error:', error);
        this.isProcessing = false;
        if (dropdown) dropdown.classList.remove('gift-wrap-dropdown--loading');
        button.disabled = false;
        alert('ギフトラッピングの追加に失敗しました。');
      }
    },
    async removeGiftWrap(button) {
      if (this.isProcessing) return;
      this.isProcessing = true;
      button.disabled = true;
      const lineKey = button.dataset.wrapLineKey;
      const dropdown = button.closest('[data-gift-wrap-dropdown]');
      if (dropdown) dropdown.classList.add('gift-wrap-dropdown--loading');
      try {
        const response = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: lineKey, quantity: 0 })
        });
        if (!response.ok) throw new Error('Failed to remove gift wrap');
        window.location.reload();
      } catch (error) {
        console.error('[GiftWrapping] Remove error:', error);
        this.isProcessing = false;
        if (dropdown) dropdown.classList.remove('gift-wrap-dropdown--loading');
        button.disabled = false;
        alert('ギフトラッピングの削除に失敗しました。');
      }
    },
    toggleProductOptions(checkbox) {
      const container = checkbox.closest('.gift-wrapping');
      const optionsEl = container?.querySelector('[data-gift-wrapping-options]');
      if (optionsEl) {
        optionsEl.hidden = !checkbox.checked;
        if (!checkbox.checked) {
          const priceField = container.querySelector('[data-gift-wrap-price-field]');
          if (priceField) priceField.value = '0';
        }
      }
    },
    updatePriceField(radio) {
      const container = radio.closest('.gift-wrapping');
      const priceField = container?.querySelector('[data-gift-wrap-price-field]');
      if (priceField && radio.dataset.price) priceField.value = radio.dataset.price;
    },
    /**
     * 孤立したラッピング商品を自動削除
     * 親商品が削除されてラッピングだけ残った場合に対応
     * 2026-07 fix: ループブレーカー追加。
     * 削除→reload→再検出→reload…の無限ループを防止するため、
     * 直近20秒以内にクリーンアップ実行済みの場合はスキップする。
     */
    async cleanOrphanedWraps() {
      const LOOP_KEY = 'gift-wrap-cleanup-ts';
      const LOOP_WINDOW_MS = 20000;
      try {
        const lastRun = parseInt(sessionStorage.getItem(LOOP_KEY), 10) || 0;
        if (Date.now() - lastRun < LOOP_WINDOW_MS) {
          console.warn('[GiftWrapping] Cleanup skipped (loop breaker active)');
          return;
        }
        const response = await fetch('/cart.js');
        const cart = await response.json();
        const allKeys = cart.items.map(item => item.key);
        const orphaned = cart.items.filter(item => {
          if (!item.properties || !item.properties['_gift_wrap_type']) return false;
          const parentKey = item.properties['_parent_line_key'];
          if (!parentKey) return true;
          return !allKeys.includes(parentKey);
        });
        if (orphaned.length === 0) return;
        console.log('[GiftWrapping] Removing', orphaned.length, 'orphaned wrap(s)');
        sessionStorage.setItem(LOOP_KEY, String(Date.now()));
        const updates = {};
        orphaned.forEach(item => { updates[item.key] = 0; });
        const updateRes = await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates })
        });
        // 2026-07 fix: 削除が成功した場合のみリロード（失敗時のリロード連鎖を防止）
        if (updateRes.ok) {
          window.location.reload();
        } else {
          console.error('[GiftWrapping] Orphan removal failed:', updateRes.status);
        }
      } catch (error) {
        console.error('[GiftWrapping] Orphan cleanup error:', error);
      }
    }
  };
  window.GiftWrapping = GiftWrapping;
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => GiftWrapping.init());
  } else {
    GiftWrapping.init();
  }
})();
}